//  ----------------------------------------------------------------------------
//  Dependencies
//  ----------------------------------------------------------------------------
import { shallowEqual, useSelector } from 'react-redux'



//  ----------------------------------------------------------------------------
//  Selectors
//  ----------------------------------------------------------------------------

//  -- Examples data ------------------
const selectore = (state) => state.one_game_video;
//  -- Examples array selector --------



export const useOneGameVideo = () =>{
    const selectedData = useSelector(selectore, shallowEqual)
    return selectedData;
}